const mexicoTranslations = {
  "v2.benefits.health-insurance.name": `v2.benefits.medical-expense.name`,
};

export default mexicoTranslations;
